import React from 'react';
import {
  RefreshControl as RNRefreshControl,
  RefreshControlProps,
} from 'react-native';

import type { ColorType } from '@types';
import { useColors } from '@hooks';

export interface IRefreshControl extends RefreshControlProps {
  color?: ColorType;
}

export function RefreshControl({
  color = '$primary300',
  ...props
}: IRefreshControl) {
  const colors = useColors();

  const colorInHex = colors[color];

  return (
    <RNRefreshControl
      tintColor={colorInHex}
      colors={[colorInHex]}
      {...props}
    />
  );
}
